<template>
  <header class="header">
    <div class="container header__container">
      <div class="header__logo-area">
        <router-link :to="homeLink" class="header__logo">Arynae</router-link>
        <!-- Placé ici à côté du logo -->
        <LanguageSwitcher class="header__lang-switcher" />
      </div>
      
      <!-- Bouton hamburger pour mobile -->
      <div class="header__mobile-toggle" @click="isMenuOpen = !isMenuOpen">
        <span></span>
        <span></span>
        <span></span>
      </div>
      
      <nav class="header__nav" :class="{'header__nav--open': isMenuOpen}">
        <template v-for="item in localizedMenuItems" :key="item.path">
          <!-- Liens standards avec router-link -->
          <router-link 
            v-if="!item.obfuscated"
            :to="item.path"
            class="header__nav-item"
            :class="{ 'header__nav-item--accent': item.accent }"
            @click="isMenuOpen = false"
          >
            {{ item.name }}
          </router-link>
          
          <!-- Liens obfusqués avec span -->
          <span
            v-else
            @click="navigateAndClose(item.path)"
            class="header__nav-item fake-link"
            :class="{ 'header__nav-item--accent': item.accent }"
          >
            {{ item.name }}
          </span>
        </template>
      </nav>
    </div>
  </header>
</template>

<script>
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'

export default {
  name: 'TheHeader',
  components: {
    LanguageSwitcher
  },
  data() {
    return {
      isMenuOpen: false,
      menuItems: [
        { name: 'SaaS', path: '/saas', accent: false, obfuscated: false },
        { name: 'No Code', path: '/nocode', accent: false, obfuscated: false },
        { name: 'SEO', path: '/seo', accent: false, obfuscated: false },
        { name: 'Chatbot', path: '/chatbot', accent: false, obfuscated: false },
        { name: 'Data Science', path: '/datascience', accent: false, obfuscated: false },
        { name: 'Contact', path: 'p1', accent: true, obfuscated: true }
      ]
    }
  },
  computed: {
    localizedMenuItems() {
      const currentLocale = this.$route.meta?.locale || 'fr';
      
      return this.menuItems.map(item => {
        // Ne pas modifier les chemins obfusqués
        if (item.obfuscated) {
          return { ...item };
        }
        
        // Adapter le chemin selon la langue actuelle
        const path = currentLocale === 'en' && !item.path.startsWith('/en')
          ? `/en${item.path === '/' ? '' : item.path}`
          : item.path;
          
        return { ...item, path };
      });
    },

    homeLink() {
    const currentLocale = this.$route.meta?.locale || 'fr';
    return currentLocale === 'en' ? '/en' : '/';
  }
    
  },
  methods: {
    navigateTo(path) {
      const currentLocale = this.$route.meta?.locale || 'fr';
      const routes = {
        'p1': '/contact'
      };
      
      let targetPath = routes[path] || path;
      
      // Ajouter le préfixe /en pour les liens obfusqués si nécessaire
      if (currentLocale === 'en' && targetPath.startsWith('/') && !targetPath.startsWith('/en')) {
        targetPath = `/en${targetPath}`;
      }
      
      this.$router.push(targetPath);
    },
    navigateAndClose(path) {
      this.navigateTo(path);
      this.isMenuOpen = false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.header {
  background-color: $white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: $spacing-md 0;
  position: sticky;
  top: 0;
  z-index: 10;
  
  &__logo-area {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  
  &__lang-switcher {
    margin-left: 10px;
  }



  &__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  &__logo {
    font-size: 24px;
    font-weight: bold;
    color: $dark-text;
  }
  
  &__nav {
    display: flex;
    gap: $spacing-sm;
    align-items: center;
  }
  
  &__nav-item {
    padding: 6px $spacing-md;
    border-radius: $border-radius-md;
    font-size: 14px;
    background-color: $light-gray;
    
    &--accent {
      background: $accent-gradient;
      color: $white;
    }
    
    &.router-link-active {
      font-weight: bold;
    }
  }
  
  &__mobile-toggle {
    display: none;
  }
  
  &__lang-switcher {
    margin-left: 10px;
  }
}

@media (max-width: $breakpoint-md) {
  .header {
    &__mobile-toggle {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 24px;
      height: 18px;
      cursor: pointer;
      z-index: 20;
      
      span {
        height: 2px;
        width: 100%;
        background-color: $dark-text;
        transition: all 0.3s ease;
      }
    }
    
    &__logo-area {
      display: flex;
      align-items: center;
      gap: 10px;
    }



    &__nav {
      position: absolute;
      top: 60px;
      right: 20px;
      flex-direction: column;
      background-color: $white;
      padding: $spacing-md;
      border-radius: $border-radius-md;
      gap: $spacing-md;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
      max-width: 200px;
      transform: scale(0.95);
      opacity: 0;
      visibility: hidden;
      transform-origin: top right;
      transition: all 0.2s ease;
      
      &--open {
        transform: scale(1);
        opacity: 1;
        visibility: visible;
      }
    }
    
    &__nav-item {
      width: 100%;
      text-align: center;
      white-space: nowrap;
    }
    
    &__lang-switcher {
      margin-left: 0;
      margin-top: 10px;
      width: 100%;
    }
  }
}

//Style obfuscation des liens
.fake-link {
  cursor: pointer;
}
</style>